import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../../services/auth';

function ProtectedRoute({ children }) {
  // Check if the user is authenticated
  const authenticated = isAuthenticated();
  
  // If not authenticated, redirect to login
  if (!authenticated) {
    // Check if we're already on the login page to prevent redirect loops
    if (window.location.pathname !== '/login') {
      return <Navigate to="/login" replace />;
    }
  }

  return children;
}

export default React.memo(ProtectedRoute); 